module.exports = __webpack_public_path__ + "assets/images/project/constituencies/kebun-baru-smc.jpg?v=a3abfa00";